import { SuperService } from './../../../core/services/super.service';
import { UserService } from './../../../core/services/user.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import * as fromUserActions from './user.actions';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class UserEffects {
	constructor(
		private actions$: Actions,
		private userService: UserService,
		private superService: SuperService
	) {}

	doLoadUser$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromUserActions.doLoadUser),
			mergeMap(() => {
				return this.userService.getSelfUserOp().pipe(
					map((userAtt) => {
						const user = {};

						userAtt.UserAttributes.forEach((att) => {
							if (att.Name === 'phone_number') {
								user['phone'] = att.Value;
							} else if (att.Name === 'name') {
								user['name'] = att.Value;
							} else if (att.Name === 'gender') {
								user['gender'] = att.Value;
							} else if (att.Name === 'email') {
								user['email'] = att.Value;
							} else if (att.Name === 'custom:role') {
								user['role'] = att.Value;
							} else if (att.Name === 'locale') {
								user['locale'] = att.Value;
							}
						});

						return fromUserActions.doLoadUserSuccess({ user });
					}),
					catchError(() => of(fromUserActions.doLoadUserFailure()))
				);
			})
		)
	);

	doLoadUsersStandard$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromUserActions.doLoadUsersStandard),
			mergeMap(() => {
				return this.userService.getB2GUsers().pipe(
					map((users) => {
						return fromUserActions.doLoadUsersStandardSuccess({ users });
					}),
					catchError(() => of(fromUserActions.doLoadUsersStandardFailure()))
				);
			})
		)
	);

	doLoadUsersSuper$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fromUserActions.doLoadUsersSuper),
			mergeMap(() => {
				return this.superService.getB2GUsers().pipe(
					map((users) => {
						return fromUserActions.doLoadUsersSuperSuccess({ users });
					}),
					catchError(() => of(fromUserActions.doLoadUsersSuperFailure()))
				);
			})
		)
	);
}
